export default __webpack_public_path__ + "static/media/105t.4f060fe5.jpg";